import * as React from "react";
const SvgDiagnose20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 3a6 6 0 1 0 0 12A6 6 0 0 0 9 3ZM1 9a8 8 0 1 1 14.32 4.906l3.594 3.594-1.414 1.414-3.594-3.594A8 8 0 0 1 1 9Zm11.414-1L9.726 5.312l-2 4L6.414 8H4v2h1.586l2.688 2.688 2-4L11.586 10H14V8h-1.586Z",
      clipRule: "evenodd"
    })
  );
export default SvgDiagnose20Px;
